import { error } from "console";
import { Component, OnInit } from "@angular/core";
import { AuthConstants } from "../config/auth-constants";
import { AngularFireAuth } from "@angular/fire/compat/auth";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { LoadingController, Platform, ModalController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import * as firebase from "firebase/compat";
import { GlobalsService } from "../api/globals.service";
import { AuthService } from "../services/auth.service";
import { SearchService } from "../services/search.service";
import { StorageService } from "../services/storage.service";
import { ToastService } from "../services/toast.service";
import { TranslationLoadedService } from "../services/translation-loaded.service";
import { PerfilService } from "../services/perfil.service";

@Component({
  selector: "app-delete-user",
  templateUrl: "./delete-user.component.html",
  styleUrls: ["./delete-user.component.scss"],
})
export class DeleteUserComponent implements OnInit {
  contactForm: FormGroup;

  isLogin: boolean;
  user = null;
  isMobile = this.platform.is("mobile");
  displayUserData: any;
  isIos = false;

  public loaderToShow;
  ismobile: boolean;
  constructor(
    public globalsService: GlobalsService,
    private router: Router,
    public toastService: ToastService,
    public loadingCtrl: LoadingController,
    private platform: Platform,
    public fireAuth: AngularFireAuth,
    private formBuilder: FormBuilder,
    private perfilService: PerfilService,
    private authService: AuthService
  ) {
    this.isIos = globalsService.plataforma == "ios" ? true : false;
    this.ismobile = globalsService.isMobile;

    this.authService.userData$.subscribe((res: any) => {
      if (res) {
        this.displayUserData = res;
      }
    });
  }

  ngOnInit() {
    this.contactForm = this.formBuilder.group({
      correo: ["", [Validators.required, Validators.email]],
      contrasena: ["", Validators.required],
    });
  }

  onSubmit() {
    this.showLoader();
    this.perfilService
      .desactiveAcount(
        this.displayUserData.id,
        this.displayUserData.auth_key,
        this.contactForm.value
      )
      .subscribe((res: any) => {
        this.toastService.presentToast(res.message);
        this.hideLoader();
        if (res.success) {
          this.router.navigate(["login"]);
        }
      });
  }

  getTime() {
    this.router.navigate(["/auth/login"]);
  }

  showLoader() {
    this.loaderToShow = this.loadingCtrl
      .create({
        message: "Cargando...",
      })
      .then((res) => {
        res.present();
        res.onDidDismiss().then((dis) => {});
      });
  }

  hideLoader() {
    setTimeout(() => {
      if (this.loadingCtrl) this.loadingCtrl.dismiss();
    }, 100);
  }
}
